export const waitForTimeoutPromise = (timeout) => new Promise((resolve) => {
    setTimeout(resolve, timeout);
});
